import React from 'react'
import checkForInfinityOrNaN from 'helpers/presentation/checkForInfinityOrNaN'

class Overlay extends google.maps.OverlayView {
  constructor({ map }) {
    super()
    this.display = false
    this.setMap(map)
  }

  onAdd() {
    const el = this.el = document.createElement('div')
    el.style.position = 'absolute'
    el.style.color = 'black'
    el.style.fontWeight = 'bold'
    let panes = this.getPanes()
    panes.overlayMouseTarget.appendChild(el)
  }

  update({ ppf, ppfHoverPosition, isImperial, activeInUI }) {
    if (!this.el) return
    this.ppf = checkForInfinityOrNaN(ppf) ? undefined : ppf.toFixed()
    this.position = ppfHoverPosition
    this.isImperial = isImperial
    this.display = typeof ppf !== 'undefined' && typeof ppfHoverPosition !== 'undefined' && activeInUI
    this.draw()
  }

  draw() {
    const { el, ppf, position, isImperial, display } = this
    if (!display) {
      el.style.display = 'none'
      return
    }

    el.style.display = 'block'
    el.textContent = `${ppf} ${isImperial ? 'ppf' : 'ppm'}`

    const overlayProjection = this.getProjection()
    const latLngPxl = overlayProjection.fromLatLngToDivPixel(position)

    el.style.left = `${latLngPxl.x + 20}px`
    el.style.top = `${latLngPxl.y}px`
  }

  onRemove() {
    this.el.parentNode.removeChild(this.el)
  }
}

export default class extends React.Component {
  constructor({ map, addToMarkers }) {
    super()
    this.overlay = new Overlay({ map })
    addToMarkers('ppfHoverPreviewOverlay', this.overlay)
  }

  componentWillReceiveProps(nextProps) {
    const { ppfHoverPosition, ppf, activeInUI, isImperial } = nextProps
    this.overlay.update({ ppf, ppfHoverPosition, activeInUI, isImperial })
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/PpfHoverPreview.js